const SvgBlank = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16">
    <path fill="#fff" fillRule="evenodd" d="M0 .063v15.92h16V.063zm9 14.92h6v-6zm6-7.864V1.063H8.944zM7.134 1.063H1v6.134zM1 8.983v6h6zM8.04 1.56l6.492 6.492L8 14.583 1.508 8.09z" clipRule="evenodd" />
  </svg>;
export default SvgBlank;